var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferOpd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_447_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 40,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 -18.3333V1.66675",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 38.8281H6.66699V7.21359H33.3336V38.8281Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9639 13.7499V19.5833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04688 16.6667H13.8802",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 16.6667H29.9996",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 29.1147H18.3336",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 34.1145H21.667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.1147H27.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.1145H27.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6615 4.47883C23.4742 2.62156 21.9062 1.17188 19.9996 1.17188C18.0929 1.17188 16.525 2.62156 16.3376 4.47883H11.7178V10H28.2813V4.47883H23.6615Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.885 2.5V10H29.1152V2.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9635 9.99989C14.6454 9.99989 17.6302 12.9847 17.6302 16.6665C17.6302 20.3485 14.6454 23.3333 10.9635 23.3333C7.28164 23.3333 4.29688 20.3485 4.29688 16.6665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_447_7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_447_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_447_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 -18.3333V1.66675",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 38.8281H6.66699V7.21359H33.3336V38.8281Z",
    fill: "#17468C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_447_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_447_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 38.8281H6.66699V7.21359H33.3336V38.8281Z",
    stroke: "#17468C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9639 13.7499V19.5833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04688 16.6667H13.8802",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 16.6667H29.9996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 29.1147H18.3336",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 34.1147H21.667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.1147H27.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.1145H27.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_447_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_447_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6615 4.47883C23.4742 2.62156 21.9062 1.17188 19.9996 1.17188C18.0929 1.17188 16.525 2.62156 16.3376 4.47883H11.7178V10H28.2813V4.47883H23.6615Z",
    fill: "#17468C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6615 4.47883C23.4742 2.62156 21.9062 1.17188 19.9996 1.17188C18.0929 1.17188 16.525 2.62156 16.3376 4.47883H11.7178V10H28.2813V4.47883H23.6615Z",
    stroke: "#17468C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.885 2.5V10H29.1152V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9635 9.99989C14.6454 9.99989 17.6302 12.9847 17.6302 16.6665C17.6302 20.3485 14.6454 23.3333 10.9635 23.3333C7.28164 23.3333 4.29688 20.3485 4.29688 16.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferOpd);
export default __webpack_public_path__ + "static/media/refer-opd.457ef03a3ed1b0400eee64a81d3524b7.svg";
export { ForwardRef as ReactComponent };